import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * DEMO / TRIAL ONLY — a soft "please double-check this" note shown under a field flagged by a
 * demo regularization scenario. Amber, advisory tone — deliberately not an error (red).
 * Renders nothing unless a flag message is passed, so it is inert in every real flow.
 */
const FieldFlag = ({ flaggedFields, name }) => {
  const message = flaggedFields && typeof flaggedFields.get === 'function' ? flaggedFields.get(name) : null;
  if (!message) return null;
  return (
    <p className="mt-1 flex items-start gap-1.5 text-xs font-medium text-amber-700" role="status">
      <Icon name="Flag" size={12} className="mt-0.5 flex-shrink-0" />
      {message}
    </p>
  );
};

export default FieldFlag;
